import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "../styles/default.css"
import "../styles/timeline.css"
import { useTranslation } from "react-i18next"

const contents = [
  {
    title: "q1",
    body1: "q1Body1",
    body2: "q1Body2",
    id: "a",
  },
  {
    title: "q2",
    body1: "q2Body1",
    body2: "q2Body2",
    id: "a",
  },
  {
    title: "q3",
    body1: "q3Body1",
    body2: "q3Body2",
    id: "c",
  },
]

export default function Timeline() {
  const { t } = useTranslation()
  return (
    <section className="timeline-area bg-light pt-75">
      <div className="timeline-header bg-white">
        <Container>
          <Row>
            <Col lg={12}>
              <h1 className="title-section-inside">&lt; Timeline</h1>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="timeline-item">
        <Container>
          <Row className="d-flex align-items-center">
            <Col lg={10} className="mt-50">
              {contents.map((content, i) => (
                <div className="timeline-list" id={content.id} key={i}>
                  <div
                    className="timeline-list-content ml-90 mb-40"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    <h6 className="text-content">{t(content.title)}</h6>
                    <p className="description">{t(content.body1)}</p>
                    <p className="description">{t(content.body2)}</p>
                  </div>
                </div>
              ))}
            </Col>
            <span className="progress-text d-none d-lg-block">
              Our Progress
            </span>
          </Row>
        </Container>
      </div>
    </section>
  )
}
